import React from "react";
import glamorous from "glamorous";
import _ from "lodash";
import moment from "moment";

import FaTrash from "react-icons/lib/ti/trash";
import FaPencil from "react-icons/lib/ti/pencil";
import { FlexDiv, FlexColDiv } from "../../styles/container-elements";
import colors from "../../styles/colors";

const TIME_FORMAT = "HH:mm";
const DATE_FORMAT = "M/D/YY";

const SearchItem = ({ lbl, val }) => {
  return (
    <glamorous.Div style={{ fontSize: "x-small" }}>
      <glamorous.Span css={{ fontStyle: "italic" }}>{lbl}</glamorous.Span>
      {" : "}
      <glamorous.Span css={{ fontWeight: "bold" }}>{val}</glamorous.Span>
    </glamorous.Div>
  );
};

const formatLabel = lbl => _.capitalize(_.replace(lbl, "_", " "));

function getMappedValue(key, val, rest) {
  const {
    statustypes,
    execptiontypes,
    shipmentmodes,
    carriers,
    locations
  } = rest;
  let mapped = "";

  switch (key) {
    case "status":
      mapped =
        statustypes && !_.isEmpty(statustypes)
          ? statustypes.find(o => o.id === val).name
          : "";
      break;
    case "active_exception":
      mapped =
        execptiontypes && !_.isEmpty(execptiontypes)
          ? execptiontypes.find(o => o.id === val).name
          : "";
      break;
    case "mode":
      mapped =
        shipmentmodes && !_.isEmpty(shipmentmodes)
          ? shipmentmodes.find(o => o.id === val).name
          : "";
      break;
    case "carrier":
      mapped =
        carriers && !_.isEmpty(carriers)
          ? carriers.find(o => o.id === val).name
          : "";
      break;
    case "destination":
    case "origin":
      mapped =
        locations && !_.isEmpty(locations) && _.size(locations) > 1
          ? locations.find(o => o.id === val).name
          : "";
      break;
    case "pickup":
    case "delivery":
      let dfrom = Date.parse(val.from);
      let dto = Date.parse(val.to);
      mapped = `from: ${moment(dfrom).format(DATE_FORMAT)} ${moment(
        dfrom
      ).format(TIME_FORMAT)} 
        to: ${moment(dto).format(DATE_FORMAT)} ${moment(dto).format(
        TIME_FORMAT
      )}`;
      break;
    case "shipment_id":
    case "part_number":
    case "vin":
      mapped = val;
      break;
    default:
      break;
  }

  return mapped;
}

function parseSearch(search, rest) {
  let elem = [];
  let keys = _.keys(search);

  keys.forEach((key, i) => {
    const mappedVal = getMappedValue(key, search[key], rest);

    elem.push(<SearchItem key={i} lbl={formatLabel(key)} val={mappedVal} />);
    if (i < _.size(keys) - 1)
      elem.push(
        <glamorous.Div
          key={`${i}-seperator`}
          style={{ fontSize: "x-small", marginRight: ".25em" }}
        >
          {","}
        </glamorous.Div>
      );
  });

  return (
    <FlexDiv
      css={{
        color: colors.text.HIT_GRAY,
        marginLeft: "0.5em",
        marginRight: "0.5em",
        flexWrap: "wrap",
        display: "inline-flex"
      }}
    >
      {elem}
    </FlexDiv>
  );
}

const SavedSearchCellRenderer = props => {
  const { original } = props;

  if (original == null) return <glamorous.Div height="100%" />;

  let searchElem = original.search
    ? parseSearch(original.search, props.columnProps.rest)
    : null;

  return (
    <FlexColDiv height="100%" alignItems="center">
      <FlexDiv
        css={{ marginLeft: "0.5em", marginRight: "0.5em", width: "100%" }}
      >
        {original.name}
      </FlexDiv>
      {searchElem}
    </FlexColDiv>
  );
};

const ActionCellRenderer = props => {
  const { original } = props;
  const { actionhandler } = props.columnProps.rest;
  const linkStyle = {
    textDecoration: "underline",
    color: colors.text.HIT_GRAY,
    cursor: "pointer",
    fontSize: 12
  };
  const markerStyle = { margin: "0 20 0 2", fontSize: 18 };

  return (
    <glamorous.Div
      css={{
        display: "flex",
        justifyContent: "center",
        alignItems: "space-around",
        fontWeight: 400,
        fontStyle: "italic"
      }}
    >
      <p>
        <a style={linkStyle} onClick={() => actionhandler(original, "RENAME")}>
          Rename <FaPencil style={markerStyle} />
        </a>
      </p>
      <p>
        <a style={linkStyle} onClick={() => actionhandler(original, "DELETE")}>
          Delete <FaTrash style={markerStyle} />
        </a>
      </p>
    </glamorous.Div>
  );
};

export const getColumns = (
  savedSearches,
  actionhandler,
  statustypes,
  execptiontypes,
  shipmentmodes,
  carriers,
  locations
) => {
  return [
    {
      Header: "Seach Name",
      Cell: SavedSearchCellRenderer,
      minWidth: 200,
      getProps: () => {
        return {
          statustypes,
          execptiontypes,
          shipmentmodes,
          carriers,
          locations
        };
      }
    },
    {
      Header: "Actions",
      id: "actionCell",
      minWidth: 150,
      style: {
        minWidth: 150,
        display: "flex",
        justifyContent: "center"
      },
      Cell: ActionCellRenderer,
      getProps: () => {
        return { actionhandler };
      }
    }
  ];
};



// WEBPACK FOOTER //
// ./src/modules/profile/SavedSearchColumns.js